import React, { HTMLAttributes, useCallback } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";

import XtSvg from "components/xt/svg";

import { AppModalTransferProps } from "components/app/modal/transfer";
import { AccountEnum } from "store/balances";

const { useTranslation } = Hooks;
// const { getUrl } = Util;

interface Props extends Omit<HTMLAttributes<HTMLButtonElement>, "title">, AppModalTransferProps {
  isIcon?: boolean;
  onClick?: () => void; //点击回调
}

const Transfer: React.FC<Props> = ({ className, children, isIcon, onClick, currency }) => {
  const t = useTranslation();
  // const router = useRouter();
  const { name, isLever } = store.market;
  const { isLogin,authInfo } = store.user;

  const handleClick = useCallback(() => {
    onClick && onClick();
    if (!isLogin) return;

    const obj: AppModalTransferProps = !isLever
      ? {
          // accountFrom: AccountEnum.spot,
          accountTo: AccountEnum.spot,
          currency,
        }
      : {
          // accountFrom: AccountEnum.spot,
          accountTo: AccountEnum.lever,
          currency,
          leverSymbol: name,
        };

    /*
    const obj: AppModalTransferProps = {
      // accountFrom: AccountEnum.spot,
      // accountTo: AccountEnum.futures_c,
      currency,
      leverSymbol: name,
    };
     */

    store.trade.updateState({
      modalTransfer: {
        open: true,
        ...obj,
      },
    });
  }, [isLogin, isLever, currency, name]);

  if(!authInfo || !authInfo.country || authInfo.country.code == 971)
    return null;

  return (
    <button className={cx("btnTxt", className)} onClick={handleClick}>
      {children || (isIcon ? <XtSvg icon={"transfer"} /> : t("trade.transfer"))}
    </button>
  );
};

export default observer(Transfer);
